import { gql } from "@apollo/client";

export const STREAM_CLOSE = gql`
  mutation streamClose($id: Int!) {
    streamClose(id: $id) {
      id
      message
      isError
    }
  }
`;
